import { Link as RemixLink, useMatches } from "@remix-run/react";
import {
  Breadcrumb as ChakraBreadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { ArrowBackIcon as BackIcon } from "@chakra-ui/icons";

// Right now, breadcrumb can only be a single back button,
// to be rendered in the app layout

export function Breadcrumb(boxProps) {
  const matches = useMatches();

  const breadcrumbs = matches
    // skip routes that don't have a breadcrumb
    .filter((match) => match.handle && match.handle.breadcrumb)
    // render breadcrumbs!
    .flatMap((match, index) => match.handle.breadcrumb(match));

  const lastBreadcrumbs = breadcrumbs.slice(-1);

  return lastBreadcrumbs.map(({ to, text }) => {
    return (
      <Button
        key={text}
        variant="link"
        colorScheme="brand"
        leftIcon={<BackIcon />}
        as={RemixLink}
        to={to}
      >
        {text}
      </Button>
    );
  });
}
